import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {debounceTime, Observable, Subject} from 'rxjs';
import {BaseHubService} from './base-hub.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorHubService extends BaseHubService {
    private static HUB_ROUTE: string = "/errorNotificationHub";

    private newErrorRegistered = new Subject<boolean>;

    protected override getUrl(): string {
        return environment.clickkerWatcher.webSocket.url + ErrorHubService.HUB_ROUTE;
    }

    protected override registerListeners() {
        this.hubConnection?.on("ErrorRegistered", (isRegistered: boolean) => {
            this.newErrorRegistered.next(isRegistered);
        });
    }

    public newErrorIsRegistered(): Observable<boolean> {
        return this.newErrorRegistered.asObservable().pipe(
            debounceTime(30000)
        );
    }
}
